import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React from "react";
import Button from "@src/components/UIElements/Button";
import styles from "./MoneyBackBottomSheet.module.scss";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";


const MoneyBackBottomSheet = ( {handleOnContinue = ()=> {}, handleClose}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.AllStates}>
      <Modal
        customClass={styles.AllStates__modalCustomStyle}
        isCloseButtonVisible= {false}
        modalBackdropClass={styles.AllStates__modalBackdropClass}
        handleClose={() => handleClose(false)}
      >
        <div className={styles.AllStates__States}>
          <div
            className={styles.AllStates__States__heading}>
              {t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.100PercentRefundGuaranteed",
                      "100% Refund Guaranteed"
                    )}
            <br />
            <span className={styles.AllStates__States__heading__noRisk}>{t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.noRiskJustLearning",
                      "No risk, just learning!"
                    )}</span>
          </div>
          <div className={styles.AllStates__States__moneyBack}>
            <p className={styles.AllStates__States__moneyBack__text}> 
                MONEY BACK
                <br />
                GUARANTEE
            </p> 
            <div className={styles.AllStates__States__moneyBack__contentContainer}>
              <div className={styles.AllStates__States__moneyBack__contentContainer__info}>
                <Image
                    src={getAwsAssets("moneyBackChecked.svg", "bottomSheets")}
                    alt={t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.moneyBackChecked",
                      "moneyBackChecked"
                    )}
                    width="22px"
                    height="22px"
                />
                <p>
                  <span className={styles.AllStates__States__moneyBack__contentContainer__info__text}>{t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.getAFullRefund",
                      "Get a full refund "
                    )}</span>
                  {t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.ifYouAreNotSatisfied",
                      "if you're not satisfied."
                    )}
                </p>
              </div>
              <div className={styles.AllStates__States__moneyBack__contentContainer__info}>
                <Image
                    src={getAwsAssets("moneyBackChecked.svg", "bottomSheets")}
                    alt={t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.moneyBackChecked",
                      "moneyBackChecked"
                    )}
                    width="22px"
                    height="22px"
                />
                <p>
                  {t(
                      "components.bottomSheets.components.MoneyBackBottomSheet.learnWithConfidence",
                      "Learn with confidence"
                    )},
                  <span className={styles.AllStates__States__moneyBack__contentContainer__info__text}> no risk attached!</span>
                </p>
              </div>
              <div className={styles.AllStates__States__moneyBack__contentContainer__tAndC}>
              *{t(
                  "components.bottomSheets.components.MoneyBackBottomSheet.termAndConditionApplied",
                  "T&C Applied"
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.AllStates__ModalFooter}>

          <div className={styles.AllStates__ModalFooter__FlexRow}>

            <Button
              outline={false}
              customClassName={styles.AllStates__ModalFooter__Button}
              onClick={() => handleOnContinue(false)}
            >
               { t(
                  "components.bottomSheets.components.DynamicBundlingBottomSheet.continue",
                  "Continue"
                )
              }
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MoneyBackBottomSheet;
